<template>
  <div class="result-overview">

  </div>
</template>

<script>
import Vue from 'vue';
import Component from "vue-class-component";
import { Prop } from 'vue-property-decorator';
import { mapState } from 'vuex';
//
@Component({
    props: {
    },
    computed: {
      ...mapState({
        steps: state => state.buyGuide.steps,
        status: state => state.buyGuide.status,
        results: state => state.buyGuide.results
      }),
    },
    components: {
    },
    methods: {
    }
})
export default class Result extends Vue {

  created() {
    // console.log('Result created');
  }

  mounted() {
  }

}

</script>

<style>

</style>
